export const NoticeCategoryType = {
    GENERAL: 'GENERAL',
    EVENT: 'EVENT',
    UPDATE: 'UPDATE',
    MAINTENANCE: 'MAINTENANCE',
};

export const NoticeCategoryLabel = {
    GENERAL: '일반',
    EVENT: '이벤트',
    UPDATE: '업데이트',
    MAINTENANCE: '점검',
};

export const NoticeCategoryColor = {
    GENERAL: 'default',
    EVENT: 'magenta',
    UPDATE: 'blue',
    MAINTENANCE: 'orange',
};
